import { Op } from 'quill-delta';

import { CollabFilter, CollabFilterJSON, MutableCollabFilter } from './view-filter';
import { CollabViewSortType, MutableSortArray, SortArray } from './view-sort';

export enum CollabLayoutType {
  TABLE = 'table',
  CARD = 'card',
  BOARD = 'board',
  CALENDAR = 'calendar',
}

export enum CollabCardWidth {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export enum CollabCoverFieldType {
  None = 'none',
  Default = 'default',
  ID = 'id',
}

export enum CollabCalculationTypes {
  SUM = 's',
  COUNT = 'c',
  COUNT_EMPTY = 'ce',
  COUNT_TOTAL = 'ct',
  COUNT_UNIQUE = 'cu',
  PERCENT_EMPTY = 'pe',
  PERCENT_NOT_EMPTY = 'pne',
  AVERAGE = 'a',
  MAX = 'ma',
  MIN = 'mi',
}

export type CollabCoverField =
  | {
      type: CollabCoverFieldType.None;
    }
  | {
      type: CollabCoverFieldType.Default;
    }
  | {
      type: CollabCoverFieldType.ID;
      id: string;
    };

export type DatabaseViewJSON = {
  name: string;
  sort: CollabViewSortType | undefined;

  layoutType: CollabLayoutType;
  cardWidth: CollabCardWidth;
  coverField: CollabCoverField;
  groupFieldId: string | undefined;
  dateFieldId: string | undefined;
  showNumberedEntries: boolean;
  wrapAllText: boolean;

  fields: Record<string, boolean> | undefined;

  filter: CollabFilterJSON | undefined;

  calculations: Record<string, CollabCalculationTypes>;

  sorts: CollabViewSortType[];
};

export interface View {
  get name(): string;
  get sort(): CollabViewSortType | undefined;

  get layoutType(): CollabLayoutType;
  get cardWidth(): CollabCardWidth;
  get coverField(): CollabCoverField;
  get groupFieldId(): string | undefined;
  get dateFieldId(): string | undefined;
  get showNumberedEntries(): boolean;
  get wrapAllText(): boolean;

  get fields(): Readonly<Record<string, boolean> | undefined>;

  get filter(): CollabFilter | undefined;

  get sorts(): SortArray;

  get calculations(): Readonly<Record<string, CollabCalculationTypes>>;
  setCalculation(fieldKey: string, value: CollabCalculationTypes): void;
  removeCalculation(fieldKey: string): void;

  toJSON(): DatabaseViewJSON;
}

export interface MutableView extends View {
  applyNameDelta(delta: Op[]): void;

  set layoutType(data: CollabLayoutType);
  set cardWidth(data: CollabCardWidth);
  set coverField(data: CollabCoverField);
  set groupFieldId(data: string | undefined);
  set dateFieldId(data: string | undefined);
  set showNumberedEntries(data: boolean);
  set wrapAllText(data: boolean);

  setFieldVisibility(
    fieldKey: string,
    fieldValue: boolean,
    dbFields: readonly string[],
    options?: { includeNewFieldInValidation?: boolean }
  ): void;
  resetFieldVisibility(): void;
  removeFieldVisibilityField(fieldKey: string, dbFields: readonly string[]): void;

  set sort(data: CollabViewSortType | undefined);

  setFilter(val: CollabFilterJSON): MutableCollabFilter;
  clearFilter(): void;

  get filter(): MutableCollabFilter | undefined;
  get sorts(): MutableSortArray;
}
